import script from "./HistorySection.vue?vue&type=script&setup=true&lang=js"
export * from "./HistorySection.vue?vue&type=script&setup=true&lang=js"

import "./HistorySection.vue?vue&type=style&index=0&id=ca0e208e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca0e208e"]])

export default __exports__